import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material'
import * as React from 'react'
import { useState } from 'react'
import { useStudyContext } from '../../../Contexts/Modules/StudyModule/SelectedStudyModule'
import { listItemsFromDataObjectArr } from '../../../Functions/ListItemGenerator'
import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { UseQueryResult } from 'react-query'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/system'
import { useUpdateAnimalPhase } from '../../../APIs/Hooks/StudyHooks'

function ChangePhaseModal({
  open,
  setOpen,
  selections,
  selectedQueries,
}: {
  open: boolean
  setOpen: any
  selections: GridRowSelectionModel
  selectedQueries: UseQueryResult[]
}) {
  const { studyQuery } = useStudyContext()
  const { study_id } = useParams()
  const [newPhase, setNewPhase] = useState<string | null>(null)
  const { mutate: updatePhase, isLoading: updateLoading } =
    useUpdateAnimalPhase(
      study_id!,
      newPhase,
      selectedQueries,
      setOpen,
      selections as number[],
    )

  const phaseOptions = listItemsFromDataObjectArr(
    studyQuery.data?.phases,
    'PhaseID',
    'PhaseID',
    'PhaseName',
    'PhaseSeq',
    studyQuery.isLoading,
  )

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        '& .MuiPaper-root': {
          maxWidth: 900,
        },
      }}
    >
      <DialogTitle>Update Animal(s) Phase</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        {`Update ${selections?.length} animals to:`}
        <FormControl
          margin="normal"
          fullWidth
        >
          <InputLabel>Phase</InputLabel>
          <Select
            value={newPhase}
            label={'Phase'}
            color="primary"
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              minWidth: 250,
            }}
            name="Lab"
            variant="outlined"
            onChange={(e) => setNewPhase(e.target.value)}
          >
            {phaseOptions}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          color={'error'}
          onClick={() => setOpen(false)}
        >
          Cancel
        </Button>
        <Box
          sx={{ ml: 1, width: 80, display: 'flex', justifyContent: 'center' }}
        >
          {updateLoading ?
            <CircularProgress />
          : <Button
              disabled={!newPhase}
              color={'success'}
              onClick={() => updatePhase()}
              autoFocus
            >
              Save
            </Button>
          }
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default ChangePhaseModal
